import { supabase } from '../supabaseClient';

export const PortalPaymentsService = {
  async listInvoices(clientId) {
    if (!clientId) return { data: [], error: new Error('Missing client id') };
    try {
      const { data: agreements, error: agreementsError } = await supabase
        .from('agreements')
        .select('id')
        .eq('client_id', clientId);
      if (agreementsError) throw agreementsError;

      const agreementIds = (agreements || []).map((a) => a.id);
      if (!agreementIds.length) {
        return { data: [], error: null };
      }

      const { data, error } = await supabase
        .from('invoices')
        .select(`
          id,
          invoice_number,
          status,
          amount_due,
          amount_paid,
          currency,
          due_date,
          created_at
        `)
        .in('agreement_id', agreementIds)
        .order('created_at', { ascending: false });
      if (error) throw error;
      return { data: data || [], error: null };
    } catch (error) {
      console.error('[PortalPaymentsService] listInvoices failed', error);
      return { data: [], error };
    }
  },

  async listPayments(clientId) {
    if (!clientId) return { data: [], error: new Error('Missing client id') };
    try {
      const { data: agreements, error: agreementsError } = await supabase
        .from('agreements')
        .select('id')
        .eq('client_id', clientId);
      if (agreementsError) throw agreementsError;

      const agreementIds = (agreements || []).map((a) => a.id);
      if (!agreementIds.length) {
        return { data: [], error: null };
      }

      const { data, error } = await supabase
        .from('payments')
        .select('id,invoice_id,amount,currency,status,method,paid_at,reference')
        .in('agreement_id', agreementIds)
        .order('paid_at', { ascending: false });
      if (error) throw error;
      return { data: data || [], error: null };
    } catch (error) {
      console.error('[PortalPaymentsService] listPayments failed', error);
      return { data: [], error };
    }
  },

  async recordPaymentIntent(payload) {
    try {
      const { data, error } = await supabase
        .from('payments')
        .insert(payload)
        .select()
        .single();
      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('[PortalPaymentsService] recordPaymentIntent failed', error);
      return { data: null, error };
    }
  }
};
